import { render, staticRenderFns } from "./ManageHotelGroups.vue?vue&type=template&id=5263ee6a"
import script from "./ManageHotelGroups.vue?vue&type=script&lang=js"
export * from "./ManageHotelGroups.vue?vue&type=script&lang=js"
import style0 from "./ManageHotelGroups.vue?vue&type=style&index=0&id=5263ee6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports